/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SortOrder } from './SortOrder';
import {
    SortOrderFromJSON,
    SortOrderFromJSONTyped,
    SortOrderToJSON,
    SortOrderToJSONTyped,
} from './SortOrder';
import type { RoleSearchOrderBy } from './RoleSearchOrderBy';
import {
    RoleSearchOrderByFromJSON,
    RoleSearchOrderByFromJSONTyped,
    RoleSearchOrderByToJSON,
    RoleSearchOrderByToJSONTyped,
} from './RoleSearchOrderBy';

/**
 * 
 * @export
 * @interface RoleSearchOrderByPaginationQuery
 */
export interface RoleSearchOrderByPaginationQuery {
    /**
     * 
     * @type {any}
     * @memberof RoleSearchOrderByPaginationQuery
     */
    pageNumber?: any | null;
    /**
     * 
     * @type {any}
     * @memberof RoleSearchOrderByPaginationQuery
     */
    pageSize?: any | null;
    /**
     * 
     * @type {SortOrder}
     * @memberof RoleSearchOrderByPaginationQuery
     */
    sortOrder?: SortOrder;
    /**
     * 
     * @type {RoleSearchOrderBy}
     * @memberof RoleSearchOrderByPaginationQuery
     */
    orderField?: RoleSearchOrderBy;
}



/**
 * Check if a given object implements the RoleSearchOrderByPaginationQuery interface.
 */
export function instanceOfRoleSearchOrderByPaginationQuery(value: object): value is RoleSearchOrderByPaginationQuery {
    return true;
}

export function RoleSearchOrderByPaginationQueryFromJSON(json: any): RoleSearchOrderByPaginationQuery {
    return RoleSearchOrderByPaginationQueryFromJSONTyped(json, false);
}

export function RoleSearchOrderByPaginationQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleSearchOrderByPaginationQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'pageNumber': json['pageNumber'] === undefined ? undefined : json['pageNumber'] === null ? null : json['pageNumber'],
        'pageSize': json['pageSize'] === undefined ? undefined : json['pageSize'] === null ? null : json['pageSize'],
        'sortOrder': json['sortOrder'] == null ? undefined : SortOrderFromJSON(json['sortOrder']),
        'orderField': json['orderField'] == null ? undefined : RoleSearchOrderByFromJSON(json['orderField']),
    };
}

export function RoleSearchOrderByPaginationQueryToJSON(json: any): RoleSearchOrderByPaginationQuery {
    return RoleSearchOrderByPaginationQueryToJSONTyped(json, false);
}

export function RoleSearchOrderByPaginationQueryToJSONTyped(value?: RoleSearchOrderByPaginationQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageNumber': value['pageNumber'],
        'pageSize': value['pageSize'],
        'sortOrder': SortOrderToJSON(value['sortOrder']),
        'orderField': RoleSearchOrderByToJSON(value['orderField']),
    };
}

